import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Lock } from "lucide-react";
import { useCart } from "@/context/CartContext";

export const Navbar = () => {
  const { count, setIsOpen } = useCart();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <header data-testid="main-navbar" className="fixed top-0 left-0 right-0 z-40 border-b border-white/10 bg-ink/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="font-syne font-extrabold text-xl tracking-tighter uppercase">
          TWELVE <span className="text-blood">12</span> SHOP
        </Link>
        <nav className="hidden md:flex items-center gap-8 font-mono text-xs tracking-[0.2em] uppercase text-smoke">
          <Link to="/" data-testid="nav-home-link" className="hover:text-white transition-colors">Accueil</Link>
          <Link to="/boutique" data-testid="nav-shop-link" className="hover:text-white transition-colors">Boutique</Link>
          <a href="/#manifeste" data-testid="nav-manifesto-link" className="hover:text-white transition-colors">Manifeste</a>
          <Link to="/contact" data-testid="nav-contact-link" className="hover:text-white transition-colors">Contact</Link>
        </nav>
        <div className="flex items-center gap-3">
          {isAdmin ? null : (
            <Link to="/admin/login" data-testid="nav-admin-link" aria-label="Espace admin"
              className="p-2 text-ash hover:text-white transition-colors">
              <Lock size={16} />
            </Link>
          )}
          <button
            data-testid="nav-cart-button"
            onClick={() => setIsOpen(true)}
            className="relative flex items-center gap-2 border border-white/15 px-4 py-2 font-mono text-xs uppercase tracking-[0.15em] hover:border-blood hover:text-blood transition-colors"
          >
            <ShoppingBag size={15} />
            <span className="hidden sm:inline">Panier</span>
            {count > 0 && (
              <span data-testid="nav-cart-count" className="absolute -top-2 -right-2 bg-blood text-white text-[10px] font-mono w-5 h-5 flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};
